<template>
  <base-dialog :value="value" title="📅 오늘의 출석" :max-width="520" closable @input="$emit('input', $event)">
    <AttendancePanel @attended="onAttended" />
  </base-dialog>
</template>

<script>
import AttendancePanel from "./AttendancePanel.vue";

export default {
  name: "AttendanceDialog",
  components: { AttendancePanel },
  props: {
    value: { type: Boolean, default: false },
  },
  methods: {
    onAttended() {
      // 출석 완료 후 잠깐 보여주고 자동 닫기
      setTimeout(() => this.$emit("input", false), 1500);
    },
  },
};
</script>
